import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';

export const roleGuard: CanActivateFn = route => {
  const authService = inject(AuthService);
  const allowedRoles = route.data['allowedRoles'] as string[] | undefined;

  if (allowedRoles?.some(role => authService.userHasRole(role))) {
    return true;
  }

  return inject(Router).createUrlTree(['/inicio']);
};